angular
  .module('zc.core')
  .component('zcApiPublicFileDownloader', {
    templateUrl: '/templates/core/components/api_public_file_downloader/api_public_file_downloader.html',
    bindings: {
      text: '=',
      filepath: '='
    },
    controller: clearanceSampleSetDownloader,
    controllerAs: 'vm'
  });

clearanceSampleSetDownloader.$inject = ['Api'];
function clearanceSampleSetDownloader(Api) {
  const vm = this;

  vm.$onInit = () => {
    vm.text = this.text;
    vm.href = Api.path(this.filepath);
  };
}



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/core/components/api_public_file_downloader/api_public_file_downloader.js